import type useMerchantAccountSettings from "./useMerchantAccountSettings";

export const enum MerchantAccountSettingsTab {
    Ledger = 'Ledger',
    ApiSettings = 'ApiSettings',
    MerchantSetup = 'MerchantSetup'
};

export type MerchantAccountSettingsContext = ReturnType<typeof useMerchantAccountSettings>;
